export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Portfolio.components.Workspace.components.Header'

export const TEXT_POSITION = {
    START: 'start',
    CENTER: 'center',
    END: 'end',
}
